import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    // Rota 404
    // 
      {
    path: '/password',
    name: 'password',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Acesso negado'
    },
    component: () => import('@/pages/acessonegado.vue')
  },
  {
    path: '/404',
    name: '404',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Página não encontrada'
    },
    component: () => import('@/pages/404.vue')
  },
  {
    path: '/',
    name: 'Home',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      // Título simples e consistente com as demais rotas. Antes usava um
      // slogan aqui, mas agora o próprio nome do site (acima) já carrega
      // esse texto descritivo - repeti-lo deixaria o título da aba do
      // navegador longo e redundante (ex.: "... Data Centers | Equipamentos
      // para ISPs & Data Center").
      title: 'Início'
    },
    component: () => import('@/pages/Home.vue')
  },
  {
    path: '/service',
    name: 'Servico',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Serviço'
    },
    component: () => import('@/pages/Servico.vue')
  },
  {
    path: '/home2',
    name: 'Home2',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: ''
    },
    component: () => import('@/pages/Home2.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Acesso',
      isLogin: true
    },
    component: () => import('@/pages/Login.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Perfil',
      isLogin: false
    },
    component: () => import('@/pages/Profile.vue')
  },
  {
    path: '/payment',
    name: 'Payment',
    props: true,
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Pagamento',
      isLogin: false
    },
    component: () => import('@/pages/Payment.vue')
  },
  {
    path: '/orders',
    name: 'Orders',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Meus Pedidos',
      isLogin: false
    },
    component: () => import('@/pages/Orders.vue')
  },
  {
    path: '/products/',
    name: 'products',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Produtos'
    },
    component: () => import('@/pages/ProductsWithBanner.vue')
  },
  {
    path: '/contato/',
    name: 'contato',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Contato'
    },
    component: () => import('@/pages/Contato.vue')
  },
  {
    path: '/seguranca/',
    name: 'seguranca',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Segurança'
    },
    component: () => import('@/pages/Seguranca.vue')
  },
  {
    path: '/garantia/',
    name: 'garantia',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Garantia'
    },
    component: () => import('@/pages/Garantia.vue')
  },
  {
    path: '/sobre/',
    name: 'sobre',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Sobre'
    },
    component: () => import('@/pages/Sobre.vue')
  },
  {
    path: '/projetos-redes/',
    name: 'projetosRedes',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Projetos de Redes'
    },
    component: () => import('@/pages/ProjetosRedes.vue')
  },
  {
    path: '/termos/',
    name: 'termos',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Termos'
    },
    component: () => import('@/pages/Termos.vue')
  },
    {
    path: '/privacidade/',
    name: 'privacidade',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Privacidade'
    },
    component: () => import('@/pages/Privacidade.vue')
  },
    {
    path: '/cookies/',
    name: 'cookies',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Cookies'
    },
    component: () => import('@/pages/Cookies.vue')
  },
  {
    path: '/product:id',
    name: 'product',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Produto'
    },
    component: () => import('@/pages/Product.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/pages/Register.vue')
  },
  {
    path: '/recovery',
    name: 'recovery',
    component: () => import('@/pages/Recovery.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Carrinho'
    },
    component: () => import('@/pages/Cart.vue')
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Lista de Desejos'
    },
    component: () => import('@/pages/Wishlist.vue')
  },

  // O antigo painel administrativo embutido neste e-commerce (rota /admin e
  // suas subrotas: /admin/produto, /admin/banco, /admin/cliente,
  // /admin/usuario, /admin/pedido, /admin/estoque, /admin/vendas,
  // /admin/orcamento, /admin/configuracao) foi removido do código-fonte.
  // Ele dependia inteiramente da API REST do backend Railway/Django
  // (endpoints como produtos/, imagens-produto/, caracteristicas-produto/,
  // situacoes-pedido/ etc.), que foi desativado, e nenhuma dessas páginas
  // era acessível a partir de nenhum link da interface atual (rotas
  // órfãs). Os recursos equivalentes (produtos, clientes, usuários,
  // pedidos, conta bancária/PIX, relatório de vendas com exportação CSV,
  // relatório de estoque, gerador de orçamento em PDF) já existem - e em
  // versões mais completas - no Gerenciador de Produtos MX3, que é agora o
  // único painel administrativo deste e-commerce.

  // Catch-all SEMPRE por último: qualquer rota não registrada cai na
  // página 404. No meio da lista, o '*' podia interceptar rotas
  // concretas declaradas depois dele (o Vue Router resolve por ordem),
  // derrubando páginas internas em 404.
  {
    path: '*',
    meta: {
      site: 'MX3 Network - Soluções de Alto Desempenho para ISPs e Data Centers',
      title: 'Página não encontrada'
    },
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Guard global
router.beforeEach((to, from, next) => {
  // O antigo painel /admin/* embutido neste e-commerce foi removido (ver
  // nota acima, na lista de rotas) - o Gerenciador de Produtos MX3 é agora
  // o único painel administrativo. Por isso não existe mais nenhuma rota
  // com `meta.requireAdmin`, e usuários logados como admin não são mais
  // redirecionados para longe do site: eles navegam normalmente, como
  // qualquer outro visitante.
  next()
})

// --- Guard global para atualizar meta tags ---
router.afterEach(async (to, from) => {
  // Atualiza o título
  if (to.meta && to.meta.title) {
    // "productNameMeta" é gravado no localStorage só pela página de produto
    // (Product.vue/components/Product.vue -> openProduct), para exibir o
    // nome do produto no título da aba enquanto o usuário está NELA. Antes
    // esse valor nunca era limpo, então, depois de visitar um produto uma
    // única vez, o título de TODAS as páginas seguintes (Home, Contato,
    // Carrinho etc.) continuava mostrando o nome daquele produto antigo
    // (ex.: "MX3 Network - Huawei NE 8000 M4 DC"). Agora só é usado quando
    // a rota atual É a de produto; em qualquer outra rota, o valor salvo é
    // descartado e o título correto da própria página é usado.
    const productNameMeta = to.name === 'product'
      ? localStorage.getItem('productNameMeta')
      : null

    if (!productNameMeta) {
      localStorage.removeItem('productNameMeta')
    }

    document.title = productNameMeta
      ? to.meta.site + ' | ' + productNameMeta
      : to.meta.site + ' | ' + to.meta.title
  }

  // Atualiza meta description
  if (to.meta && to.meta.description) {
    let descriptionTag = document.querySelector('meta[name="description"]')
    if (!descriptionTag) {
      descriptionTag = document.createElement('meta')
      descriptionTag.setAttribute('name', 'description')
      document.head.appendChild(descriptionTag)
    }
    descriptionTag.setAttribute('content', to.meta.description)
  }
})

export default router